import * as React from 'react';
import { SVGProps } from 'react';

const IconKernFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 12c4.97 0 9-2.015 9-4.5S18.97 3 14 3 5 5.015 5 7.5 9.03 12 14 12ZM5 12.337c0-.186.151-.337.337-.337.11 0 .212.054.28.14C6.926 13.814 10.186 15 14 15c3.813 0 7.073-1.186 8.384-2.86a.356.356 0 0 1 .279-.14c.186 0 .337.151.337.337V20.5c0 2.485-4.03 4.5-9 4.5s-9-2.015-9-4.5v-8.163Z" />
  </svg>
);
export default IconKernFilledSizeL;
